import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { T } from 'shared/helper/translate';
import useNavigate from '../../hooks/useNavigate';
import DropdownItems from '../../components/DropdownItems';
var RubriqAbstractCardActions = function RubriqAbstractCardActions(abstract) {
  var _abstract$abstract = abstract === null || abstract === void 0 ? void 0 : abstract.abstract,
    session = _abstract$abstract.session;
  var deleteButton = /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "dropdown-item btn fw-normal"
  }, /*#__PURE__*/React.createElement(T, {
    source: "delete"
  }));

  // setup entries for the "More" action menu
  var moreMenuItems = [{
    label: 'delete',
    element: deleteButton
  }];
  var navigate = useNavigate();
  var handleClickOpen = function handleClickOpen() {
    navigate("/rubriq/abstract-writer/".concat(session, "/criteria"));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary rubriq-ghost-button",
    onClick: function onClick() {
      return handleClickOpen();
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-arrow-up-right-from-square",
    className: "me-1"
  }), /*#__PURE__*/React.createElement(T, {
    source: "open"
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown rubriq-dropdown d-inline-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary rubriq-ghost-button dropdown-toggle",
    type: "button",
    id: "more-toggle-button",
    "data-bs-toggle": "dropdown"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.more"
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-caret-down"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu p-0",
    "aria-labelledby": "more-toggle-button"
  }, /*#__PURE__*/React.createElement(DropdownItems, {
    items: moreMenuItems
  })))));
};
export default RubriqAbstractCardActions;